<template>
  <div class="model-card-wrapper">
    <div class="model-card">
      <div class="image" :style="[model.image !== null ? {'background-image': 'url(' + model.image + ')'} : '']" @click="goto(model.url)"></div>
      <div class="content">
        <h2><a :href="model.url">{{ model.name }}</a></h2>
        <div class="available" v-if="model.online_purchase"><i class="fa fa-check" aria-hidden="true"></i> Available for Online Order</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelCard',
  props: {
    model: Object
  },
  methods: {
    goto: function (url) {
      window.location = url
    }
  }
}
</script>
